import { styled } from "../../styles/stitches.config";

export const PlainButton = styled("button", {
  $reset: "",
  cursor: "pointer",
});
